import React, { useEffect, useState } from "react"

import { Row, Col, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"

import avatar1 from "../../assets/images/users/avatar-1.jpg"
import profileImg from "../../assets/images/profile-img.png"
import Nouserimage from "../../assets/images/users/no_image.png"
import UserService from "Api/Services/UserService"
import Spinners from "components/Common/Spinner"


const WelcomeComp = () => {
    const [name, setName] = useState();
    const [username, setUserName] = useState();
    const [profileImage, setProfileImage] = useState();
    const [getdesignation, setDesignation] = useState('');
    const [getQualification, setQualification] = useState('');
    const [isLoading, setLoading] = useState(false);

    const getUser = async () => {
        setLoading(true);
        try {
            let response = await UserService.GetUser().json();
            setName(response.data.name)
            setUserName(response.data.username)
            setDesignation(response.data.designation);
            setQualification(response.data.qualification);
            // const imageUrl = `${process.env.REACT_APP_PROFILE_IMAGE_API_URL}/${response.data.profile_image}`;
            const imageUrl = response.data.profile_image
                ? `${process.env.REACT_APP_PROFILE_IMAGE_API_URL}/${response.data.profile_image}`
                : null;
            setProfileImage(imageUrl)
            setLoading(false);
            if (response.status == false) {
                setError(response.message);
                setLoading(false);
                return;
            }
        } catch (error) {
            setLoading(false);
            setError('something went wrong');
            return;
        }
    };

    useEffect(() => {
        getUser();
    }, []);
    return (
        <React.Fragment>
            {isLoading ? <Spinners setLoading={setLoading} /> :
                <Card className="overflow-hidden commonboxform">
                    <div className="bg-primary-subtle">
                        <Row>
                            <Col xs="7">
                                <div className="text-primary p-3">
                                    <h5 className="text-primary">Welcome {username ? username : 'User'} !</h5>
                                    <p> {getdesignation ? getdesignation : '-'}</p>
                                </div>
                            </Col>
                            <Col xs="5" className="align-self-end">
                                <img src={profileImg} alt="" className="img-fluid" />
                            </Col>
                        </Row>
                    </div>
                    <CardBody className="pt-0">
                        <Row>
                            <Col sm="4">
                                <div className="avatar-md profile-user-wid mb-4  rounded-circle ">
                                    <img
                                        src={profileImage ? profileImage : Nouserimage}
                                        alt=""
                                        className="img-thumbnail rounded-circle"
                                    />
                                </div>
                                <h5 className="font-size-15 text-truncate">{name ? name : '-'}</h5>
                                <p className="text-muted mb-0">{getQualification ? getQualification : '-'}</p>
                            </Col>

                            <Col sm="8">
                                <div className="pt-4">
                                    {/* <Row>
                                    <Col xs="6">
                                        <h5 className="font-size-15">125</h5>
                                        <p className="text-muted mb-0">Projects</p>
                                    </Col>
                                    <Col xs="6">
                                        <h5 className="font-size-15">$1245</h5>
                                        <p className="text-muted mb-0">Revenue</p>
                                    </Col>
                                </Row> */}
                                    <div className="mt-4">
                                        <Link
                                            to="/user-profile"
                                            className="btn btn-secondary  btn-sm font-size-15 text-truncate"
                                        >
                                            View Profile <i className="mdi mdi-arrow-right ms-1"></i>
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            }
        </React.Fragment>
    )
}
export default WelcomeComp
